import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { cartIdVar, Hooks } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { errorsMapping } from '../../mappers/errors-mapping.js';
import { useMutationConfig } from './use-mutation-config.js';
import { useUpdateCartCache } from './use-update-cart-cache.js';
import { getFlattenedCartFailureErrorCodes } from '../../utils/get-flattened-cart-error-codes.js';
import { SET_STORE } from '../../operations/mutations/set-store.js';

const useSetStore = ({ onError , onCompleted  } = {})=>{
    const cartId = cartIdVar();
    const [cart] = Hooks.useCartStorage();
    const { updateCacheWithCart  } = useUpdateCartCache();
    /**
   * Handle success and error response from mutation operation
   * @param responseData
   */ const handleOnCompleted = React__default.useCallback((responseData)=>{
        let result;
        if ('setStore' in responseData) {
            var ref;
            result = responseData.setStore;
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                const errorCodes = getFlattenedCartFailureErrorCodes(result.failures);
                onError === null || onError === void 0 ? void 0 : onError({
                    reason: 'MUTATION'
                });
                /**
           *  Notify user about all failures
           *  To handle granular errors return from mutation operation
           */ errorCodes.forEach((error)=>toast.failed(error)
                );
            }
            if (result.success) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
            }
        }
    }, [
        onCompleted,
        onError
    ]);
    const handleOnError = React__default.useCallback(()=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const { mutationOptions  } = useMutationConfig({
        onError: handleOnError,
        onCompleted: handleOnCompleted
    });
    const updateCache = React__default.useCallback((cache, { data  })=>{
        if (data && data.setStore.success) {
            const updatedCart = data.setStore.cart;
            updatedCart && updateCacheWithCart({
                cart: updatedCart,
                cache
            });
        }
    }, [
        updateCacheWithCart
    ]);
    const [mutationCallback, mutation] = useMutation(SET_STORE, swcHelpers.objectSpread({}, mutationOptions, {
        update: updateCache,
        context: {
            forwardHeaders: {
                'cart-hash': cart.cartHash
            }
        }
    }));
    /**
   *  Store data update operation
   *  @param storeCode: number
   */ const setStore = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(storeCode) {
            yield mutationCallback({
                variables: {
                    storeInput: {
                        code: storeCode,
                        checkoutId: cartId
                    }
                }
            });
        });
        return function(storeCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutationCallback,
        cartId
    ]);
    return {
        setStore,
        isUpdating: mutation.loading,
        updateError: mutation.error
    };
};

export { useSetStore };
//# sourceMappingURL=use-set-store.js.map
